import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/Code.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/Email.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/Phone.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/School.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/Science.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Paper/Paper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/adaptV4Theme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/styled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/esm/styles/ThemeProviderWithVars.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/styles/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/styled-engine/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/createContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/createBox/createBox.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/cssVars/createCssVarsProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Grid/createGrid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/RtlProvider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Stack/createStack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useTheme/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeProps/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeWithoutDefault/useThemeWithoutDefault.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/app/miembros/HeaderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/app/miembros/TeamSection.tsx");
